import React from 'react'
import { useCartStore } from '../store/useCartStore'
import {
    Box, Grid, Typography, Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow, Paper,
} from '@mui/material'


const cartItems = {
    alignItems: "center",
    // justifyContent: "space-between",
    display: "flex",
    marginBottom: "25px",
    gap: "20px",
}
const CheckoutCart = ({ cart }) => {

    // const { cart } = useCartStore()
    return (
        <div>
            <Grid item xs={12}>
                <Box
                >
                    <Typography sx={{
                        fontSize: '18px',
                        lineHeight: '25.8px',
                        fontWeight: '700',
                        fontFamily: `"Quicksand", sans-serif`,
                        color: '#253D4E',
                        paddingBottom: '8px',
                        borderBottom: '1px solid #00000024',
                        marginBottom: '10px',
                        position: 'relative',
                        '&::before': {
                            content: `""`,
                            width: '80px',
                            height: '2px',
                            background: '#008BFF',
                            position: 'absolute',
                            left: '0',
                            bottom: '0',
                        },
                    }}>Your Bag</Typography>
                    <TableContainer component={Paper} sx={{ backgroundColor: "transparent", boxShadow: "unset", width: "100%" }} className='checkout-product-list'>
                        <Table sx={{ width: "100%" }}>
                            <TableBody>
                                {(cart || []).map((product, id) => (
                                    <TableRow key={id}>
                                        {/* Image Column */}
                                        <TableCell sx={{ width: "100px" }}>
                                            <Box
                                                sx={{
                                                    border: "1px solid #2D3C67",
                                                    padding: "8px",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    height: "80px",
                                                    width: "80px",
                                                    borderRadius: "6px",
                                                    backgroundColor: "#f7f5f5",
                                                }}
                                            >
                                                {product.images?.[0] ? (
                                                    <img
                                                        src={product.images[0]}
                                                        alt={product.name || "Product"}
                                                        style={{ maxWidth: "100%", maxHeight: "100%", borderRadius: "4px" }}
                                                    />
                                                ) : (
                                                    <Typography variant="body2">No Image</Typography>
                                                )}
                                            </Box>
                                        </TableCell>

                                        {/* Details Column */}
                                        <TableCell>
                                            <Box>
                                                <Typography
                                                    sx={{
                                                        fontFamily: `"Poppins", sans-serif`,
                                                        fontWeight: 600,
                                                        fontSize: "16px",
                                                        color: "#3C3C3C",
                                                    }}
                                                >
                                                    {product.name}
                                                </Typography>

                                                {product.quantity !== undefined && (
                                                    <Typography sx={{ color: "rgba(60,60,60,0.79)", fontSize: "14px" }}>
                                                        Unit: {product.quantity}
                                                    </Typography>
                                                )}

                                                {product.color && (
                                                    <Typography sx={{ color: "rgba(60,60,60,0.79)", fontSize: "14px" }}>
                                                        Color: {product.color}
                                                    </Typography>
                                                )}

                                                {product.size && (
                                                    <Typography sx={{ color: "rgba(60,60,60,0.79)", fontSize: "14px" }}>
                                                        Size: {product.size}
                                                    </Typography>
                                                )}

                                                {product.weight && (
                                                    <Typography sx={{ color: "rgba(60,60,60,0.79)", fontSize: "14px" }}>
                                                        Weight: {product.weight}
                                                    </Typography>
                                                )}

                                                {product.total && (
                                                    <Typography
                                                        sx={{
                                                            color: "#2B3463",
                                                            fontWeight: "bold",
                                                            fontSize: "15px",
                                                            marginTop: "5px",
                                                        }}
                                                    >
                                                        ${product.total}
                                                    </Typography>
                                                )}
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Grid>
        </div>
    )
}

export default CheckoutCart
